/* this file is transformed by vux-loader */
/* eslint-disable */
import _defineProperty from "/home/travis/build/moohng/wchat/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/travis/build/moohng/wchat/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import { get } from "../../utils/request";
import * as types from "../mutation-types";
import * as api from "../../services/api";
export default {
  namespaced: true,
  state: {
    userInfo: {}
  },
  getters: {
    name: function name(state) {
      return state.userInfo.name;
    },
    username: function username(state) {
      return state.userInfo.username;
    },
    headIcon: function headIcon(state) {
      return state.userInfo.headIcon;
    },
    sex: function sex(state) {
      return state.userInfo.sex;
    },
    address: function address(state) {
      return state.userInfo.address;
    },
    aboutMe: function aboutMe(state) {
      return state.userInfo.aboutMe;
    }
  },
  actions: {
    fetchUserInfo: function () {
      var _fetchUserInfo = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_ref) {
        var commit, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit;
                _context.prev = 1;
                _context.next = 4;
                return get(api.fetchUserInfo);

              case 4:
                data = _context.sent;
                commit(types.SAVE_USER_INFO, {
                  userInfo: data
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.log('error', _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      function fetchUserInfo(_x) {
        return _fetchUserInfo.apply(this, arguments);
      }

      return fetchUserInfo;
    }()
  },
  mutations: _defineProperty({}, types.SAVE_USER_INFO, function (state, _ref2) {
    var userInfo = _ref2.userInfo;
    state.userInfo = userInfo;
  })
};